import { P360_PAGE_URL, PID_URL } from 'partner360/configs'

/**
 * Deep link to the partner's plan page, so an admin reviewing a request can open the
 * account in context. Built from the page constants rather than a literal path.
 */
export const getEspPartnerPageLink = (partnerId: string): string =>
  `/page/${P360_PAGE_URL}/${PID_URL}/${encodeURIComponent(partnerId)}`
